module.exports = __webpack_public_path__ + "fa-light-300.ttf?80329a35cee0268dc6cf640911ad9bab";